import React, { useContext, useEffect, useRef, useState } from 'react';
import { 
    Box,
    Button,
    CircularProgress,
    ClickAwayListener,
    Fade,
    Popper,
    Typography
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ClearIcon from '@mui/icons-material/Clear';
import { useAuth0 } from "@auth0/auth0-react";
import VideoFileIcon from '@mui/icons-material/VideoFile';
import ProjectContext from '../../contexts/ProjectContext';
import ItemList from '../menuitem/ItemList';
import SecondaryButton from '../buttons/SecondaryButton';
import customTheme from '../../theme';


export default function UploadExploreDialog(props) {

    const { 
        setOpen, 
        searchVisible, 
        searchAnchorEl, 
        TextField, 
        searchText, 
        requestSearch,
        IconButton,
        clearSearch
    } = props

    const [file, setFile] = React.useState('')



    
    return (
        <Popper
            open={searchVisible}
            anchorEl={searchAnchorEl}
            transition
            disablePortal
            style={{ zIndex: 1500 }}
        >

{({ TransitionProps }) => (
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Fade {...TransitionProps}>
                <TextField
                id='explore-view-search-bar'
                variant="standard"
                value={searchText}
                onChange={requestSearch}
                placeholder="  Search…"
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault()
                    }
                }}
                sx={{
                    '& input': {
                        color: 'black',
                        '&::placeholder': {
                            color: 'charcoal'
                        },
                    },
                    backgroundColor: 'white'
                }}
                InputProps={{
                    color: 'secondary',
                    endAdornment: (
                        <IconButton
                            title="Clear"
                            aria-label="Clear"
                            size="small"
                            style={{ visibility: searchText.length > 0 ? 'visible' : 'hidden' }}
                            onClick={clearSearch}>
                            <ClearIcon fontSize="medium" style={{ fill: "black" }} />
                        </IconButton>
                    )
                }}
                style={{ 
                    width: 300,
                    padding: 5
                }} />
                </Fade>
            </ClickAwayListener>
        )}











           
        </Popper>

















        
       
    )}











